<template>
  <div>
    <div
      v-if="auctionEnd"
      class="auction-not-over"
    >
      Ends in 2h 41m 58s
    </div>
    <div
      v-else-if="auctionEnd"
      class="auction-almost-over"
    >
      Ends in 9m 37s
    </div>
    <div
      v-else
      class="auction-over"
    >
      Ended Jan 7, 2020
    </div>
  </div>
</template>

<script>
export default {
  props: {
    auctionEnd: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .auction-not-over,
  .auction-almost-over,
  .auction-over {
    font-size: 80%;
  }

  .auction-almost-over {
    color: var(--red);
  }
</style>
